module.exports = __webpack_public_path__ + "media/images/avatar-1-3e45553fe12adbd45860f57239c0fe09.jpg";